import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
}), 'RepeatOneSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/RepeatOneSharp.js
// module id = 5747
// module chunks = 2